module.exports = "<textarea ckeditor-textarea\n    content-loaded=\"$ctrl.contentLoaded\"\n    ng-disabled=\"$ctrl.disabled\"\n    ng-model=\"$ctrl.model\">\n</textarea>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/RichTextEditor/EditorTextarea/editor-textarea.html
// module id = 1069
// module chunks = 0